// Google Generative AI Configuration
export const GOOGLE_GENAI_API_KEY = process.env.REACT_APP_GOOGLE_GENAI_API_KEY;

// Function to check if the API key is configured
export const isGenAIConfigured = (): boolean => {
  return !!GOOGLE_GENAI_API_KEY;
};

// Default configuration for Google Generative AI
export const defaultGenAIConfig = {
  apiKey: GOOGLE_GENAI_API_KEY,
  modelName: 'gemini-pro',
  temperature: 0.7,
  topK: 40,
  topP: 0.95,
  maxOutputTokens: 1024,
};

// Create a named export object
const genAIConfig = {
  GOOGLE_GENAI_API_KEY,
  isGenAIConfigured,
  defaultGenAIConfig,
};

export default genAIConfig; 